<template functional>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 18 18"
  >
    <g>
      <path
        d="M14.266,15a.742.742,0,0,1-.533-.222l-2.76-2.76a6.75,6.75,0,1,1,1.042-1.042l2.782,2.76A.743.743,0,0,1,14.266,15ZM6.765,1.516a5.25,5.25,0,1,0,5.25,5.25A5.256,5.256,0,0,0,6.765,1.516Z"
        transform="translate(1.485 1.484)"
        fill="#74788d"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconMagnifyingGlass',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>